import React from "react";
import { useNavigate } from "react-router-dom";
import newStyles from "../styles.module.css"; // Same CSS as EditCompanyCard

const CompanyCard = ({ companyName, adminName, adminEmail, imageFile, id }) => {
  const navigate = useNavigate();

  // Fallback text if props are missing
  const displayCompanyName = (companyName && companyName.trim()) || "No Title";
  const displayAdminName = (adminName && adminName.trim()) || "No Admin Name";
  const displayAdminEmail = (adminEmail && adminEmail.trim()) || "No Email";

  // Construct image URL
  const imageUrl = `https://starbehaviors.com/uploadimage/${imageFile}`;

  // Single button for viewing users
  const handleViewUsers = () => {
    // You can replace with actual route/ID
    navigate(`/home/view-all-users/${id}`);
  };

  return (
    <div className={newStyles.companyCard}>
      <img
        src={imageUrl}
        alt={displayCompanyName}
        className={newStyles.companyCardImage}
      />
      <h3 className={newStyles.companyCardTitle}>{displayCompanyName}</h3>
      <p className={newStyles.companyCardText}>
        <strong>Admin:</strong> {displayAdminName}
      </p>
      <p className={newStyles.companyCardText}>
        <strong>Email:</strong> {displayAdminEmail}
      </p>

      <div className={newStyles.companyCardActions}>
        <button
          onClick={handleViewUsers}
          className={newStyles.companyCardEditButton}
        >
          View Users
        </button>
      </div>
    </div>
  );
};

export default CompanyCard;
